import React from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
} from 'reactstrap';

import BaseRatesManageContainer from '../../containers/BaseRates/BaseRatesManageContainer';
import BaseRateActiveRatesContainer from '../../containers/BaseRates/BaseRateActiveRatesContainer';

export default class BaseRates extends React.Component {

  render() {

    return <div className="animated fadeIn">
      <Row>
        <Col xs="12" md="3">
          <Card>
            <CardHeader>
              Manage
            </CardHeader>
            <CardBody>
              <BaseRatesManageContainer />
            </CardBody>
          </Card>
        </Col>
        <Col xs="12" md="9">
          <Card>
            <CardHeader>
              Active Rates
            </CardHeader>
            <CardBody>
              <BaseRateActiveRatesContainer />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>;

  }

}


// WEBPACK FOOTER //
// ./src/views/BaseRates/BaseRates.js